import type { PortableTextBlock, SanityDocument, Slug } from "sanity";
import type { IFilmomtale } from "src/lib/types/Filmomtale";

const DocType_Biografi = "biografi";

interface IBiografiResult {
    biografi?: IBiografi[] | null;
    actor: ICreditedMovieSearchResult[];
    films?: ICreditedMovieSearchResult[] | null;
}


export type ICreditedMovieSearchResult = SanityDocument & Pick<IFilmomtale<false>, "title" | "drupalId" | "drupalSlug" | "fomId" | "year" | "premiere" | "premiereOverride"> & {
    isActor: boolean;
    isDirector: boolean;
    isVoice: boolean;
};


interface IBiografi extends SanityDocument {
    _type: "biografi";
    __typename: "biografi";
    name: string;
    slug: Slug;
    bodytext?: PortableTextBlock[] | null;
    birthday?: string;
    birthplace?: string;
}
/*
interface ICredit extends KeyedObject {
    movieRole: string;
    movies?: ICreditedMovie[] | null;

}

interface ICreditedMovie extends KeyedObject {
    drupalId?: number | null;
    title?: string | null;
    url?: string | null;
    year?: string | null;
}
*/
//type ICreditedMovieSearchResult = Pick<IFilmomtale<false>, "_id" | "_type" | "title" | "castV2" | "castV2Override" | "directorV2" | "directorV2Override" | "drupalSlug" | "fomId" | "year" | "premiere">;

export { DocType_Biografi };
//export type { IBiografi, ICredit, ICreditedMovie, IBiografiResult, ICreditedMovieSearchResult };
export type { IBiografiResult };
